<template>
    <div
        class="container header-container"
        :class="{
            is_modal_open:
                isShowSearch || isShowLocales || isShowCart || isShowCategories || isCartOpen || showWlNotify,
            'header-transparent': $route.name === 'index',
            scrolled: scrolled,
        }">
        <HeaderPromo class="container-ignore"></HeaderPromo>
        <div class="header" :class="{ 'header--open-menu': isShowCategories }">
            <div class="row row--fullwidth">
                <div class="col lg-4 col--no-padding">
                    <div class="header__links">
                        <div
                            v-for="(item, index) in filteredMainMenu"
                            class="header__link"
                            :class="{
                                'header__link--parent': item.children,
                                'header__link--active': isShowCategories === item.title,
                            }"
                            @mouseenter="isShowCategories = item.title"
                            @mouseleave="isShowCategories = null"
                            :key="index">
                            <nuxt-link
                                v-if="item.url"
                                :style="`color:${item.highlight || 'currentColor'}`"
                                :to="item.url"
                                class="like-link text_13 text_bold"
                                >{{ item.title }}</nuxt-link
                            >
                            <div
                                v-else
                                class="like-link text_13 text_bold"
                                :style="`color:${item.highlight || 'currentColor'}`">
                                {{ item.title }}
                            </div>
                            <transition name="fade">
                                <header-drop-down-categories-by-gender
                                    v-if="item.children && isShowCategories === item.title"
                                    :title="item.title"
                                    :top="item.children.left_top"
                                    :bottom="item.children.left_bottom"
                                    :right="item.children.right"
                                    @close="isShowCategories = null"
                                    :key="item.title"></header-drop-down-categories-by-gender>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="col lg-4 tac col--no-padding">
                    <nuxt-link class="header__logo" to="/" aria-label="На главную" @click.native="close()">
                        <img
                            data-not-lazy
                            v-lazy-load data-src="/img/logo.png"
                            v-lazy-load data-srcset="/img/logo@2x.png 2x"
                            height="36"
                            width="222"
                            draggable="false"
                            alt="" />
                        <img
                            data-not-lazy
                            v-lazy-load data-src="/img/logo-short.png"
                            v-lazy-load data-srcset="/img/logo-short@2x.png 2x"
                            height="28"
                            width="28"
                            draggable="false"
                            alt="" />
                    </nuxt-link>
                </div>
                <div class="col lg-4 col--no-padding">
                    <div class="flex flex-e">
                        <div class="header__hover header__hover--user" @click="isShowLoginPopup = !isShowLoginPopup">
                            <div class="header-user flex-c">
                                <svg-icon name="user" width="32" height="32"></svg-icon>
                                <div class="user-name text_13" v-show="userName">
                                    {{ userName || "" }}
                                </div>
                            </div>
                            <transition name="fade">
                                <LoginPopup
                                    v-if="isShowLoginPopup"
                                    v-click-outside="
                                        () => {
                                            isShowLoginPopup = false;
                                        }
                                    "></LoginPopup>
                            </transition>
                        </div>
                        <nuxt-link class="search-toggler header__hover" to="/rezultaty-poiska" aria-label="Поиск">
                            <svg-icon name="search" width="32" height="32" v-if="!isShowSearch"></svg-icon>
                        </nuxt-link>
                        <LangCurrencyChanger
                            :isShowLocales="isShowLocales"
                            @update:isShowLocales="isShowLocales = $event" />
                        <div class="header__wishlist header__hover">
                            <WishlistHeart />
                            <transition name="liveFreshItem" :duration="300">
                                <div class="wl-warn" v-if="showWlNotify">
                                    <div class="fresh-item text_11">
                                        <div class="fresh-item__content">
                                            <div class="fresh-item__data" v-if="$auth.loggedIn">
                                                <div class="flex-c color-text_2">
                                                    <div class="">{{ $t("fav_added") }}</div>
                                                    <div class="flex-c">
                                                        <svg-icon name="wishlist" width="22" height="22" />
                                                        <client-only>
                                                            <div v-if="wishlist.length">{{ wishlist.length }}</div>
                                                        </client-only>
                                                    </div>
                                                </div>
                                                <div class="fresh-item__links flex-c">
                                                    <nuxt-link to="/lk/favorites/">{{ $t("go_to_fav") }}</nuxt-link>
                                                </div>
                                            </div>
                                            <div class="fresh-item__data" v-else>
                                                <div class="color-text_2">{{ $t("fav_restrict") }}</div>
                                                <div class="fresh-item__links flex-c">
                                                    <nuxt-link to="/lk/login">{{ $t("login") }}</nuxt-link>
                                                    <nuxt-link to="/lk/register">{{ $t("register") }}</nuxt-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div class="header__cart header__hover" :class="{ 'header__cart--has-items': totalCartItems }">
                            <div class="header__cart-toggle" @click="isShowCart = true">
                                <svg-icon name="cart" width="32" height="32" />
                            </div>
                            <div class="header__cart-count text_13" v-show="totalCartItems > 0">
                                {{ totalCartItems }}
                            </div>
                            <Cart :allowChange="true" :initIsShowCart="isShowCart" @close="isShowCart = false" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <Search v-if="isShowSearch" v-click-outside="() => (isShowSearch = false)" />
        </transition>
    </div>
</template>
<script>
import WishlistHeart from "~/components/WishlistHeart";
import Search from "~/components/Search";
import Cart from "~/components/Cart";
import LangCurrencyChanger from "~/components/LangCurrencyChanger";
import LoginPopup from "~/components/LoginPopup";
import { mapGetters } from "vuex";
import HeaderDropDownCategoriesByGender from "./HeaderDropDownCategoriesByGender.vue";
import HeaderPromo from "./HeaderPromo.vue";

export default {
    name: "Header",
    components: {
        WishlistHeart,
        Cart,
        Search,
        LangCurrencyChanger,
        LoginPopup,
        HeaderDropDownCategoriesByGender,
        HeaderPromo,
    },
    data() {
        return {
            hasDrops: false,
            isShowCart: false,
            showWlNotify: false,
            isShowSearch: false,
            isShowLocales: false,
            isShowCategories: null,
            isShowLookbook: false,
            isShowLoginPopup: false,
            scrolled: false,
        };
    },
    computed: {
        ...mapGetters({
            mainMenu: "globalvars/getMainMenu",
            wishlist: "wishlist/getIds",
            orderItems: "order/getItems",
            liveFreshItem: "order/getLiveFreshItem",
            isCartOpen: "order/getCartOpenState",
            categories: "collections/getCategories",
        }),
        filteredMainMenu() {
            return this.mainMenu.filter((m) => !m.only_mobile);
        },
        totalCartItems() {
            let count = 0;
            if (process.client) {
                for (const key in this.orderItems) {
                    if (this.orderItems.hasOwnProperty(key)) {
                        const element = this.orderItems[key];
                        count += element.count;
                    }
                }
            }
            return count;
        },
        userName() {
            return (this.$auth.loggedIn && this.$auth.user?.name) || "";
        },
    },

    methods: {
        getCategoryByType(categories, type) {
            let res = {};
            for (const key in categories) {
                if (Object.hasOwnProperty.call(categories, key)) {
                    const element = categories[key];
                    if (element.type == type) {
                        res[key] = element;
                    }
                }
            }
            return res;
        },
        close() {
            this.isShowCategories = null;
            // закрываем открытое модальное окно товара при переходе на другую страницу
            // или открытии текукщего раздела
            this.$store.commit("catalog/updateProductModal", null);
        },
    },

    mounted() {
        this.$nuxt.$on("show-wl-notify", () => {
            this.showWlNotify = true;
            setTimeout(() => {
                this.showWlNotify = false;
            }, 3000);
        });
        if (localStorage.getItem("showMeCart") == "true") {
            this.isShowCart = true;
            localStorage.removeItem("showMeCart");
        }

        this.handleScroll = () => {
            const header = document.querySelector(".header");

            if (header) {
                this.scrolled = window.scrollY > 50;
            }
        };

        window.addEventListener("scroll", this.handleScroll);

        // сразу установить правильное состояние
        this.handleScroll();
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.search-toggler {
    height: 32px;
}
.header-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9; /* overlap product modal*/
    background: @bg;
    border-bottom: 1px solid @border2;
    .trs(top);

    &.header-transparent {
        background: transparent;
        border-bottom: 1px solid transparent;
        transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
        color: #fff;

        &.scrolled,
        &.is_modal_open,
        &:hover {
            color: #000;
            background: #fff;
            border-bottom: 1px solid @border2;
        }
    }
    &.is_modal_open,
    &:has(.cart.editable) {
        z-index: 9;
    }
}

.header {
    z-index: 1;
    @media @sm {
        user-select: none;
    }

    &--open-menu:after {
        opacity: 0;
    }

    .trs(box-shadow);

    &__links {
        display: flex;
        align-items: center;
    }

    &__link {
        margin-right: 44px;
        display: flex;
        align-items: center;
        height: 36px;
        position: relative;
        > .like-link {
            height: 36px;
            display: inline-flex;
            align-items: center;
        }
        a {
            transition: none;
            &:hover {
                .trs(all);
            }
        }
        .is_apple & {
            padding-top: 3px;
        }

        @media screen and (max-width: 1275px) {
            margin-right: 22px;
        }
        @media screen and (max-width: 1010px) {
            margin-right: 16px;
        }

        @media screen and (max-width: 940px) {
            margin-right: 4px;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 9px;
            left: 0;
            right: 0;
            height: 1px;
            background: #000;
            transform: scale(0, 1);
            transform-origin: left center;
            .trs(transform);
        }

        &--active {
            color: @red2;
        }

        &--parent {
            position: static;
        }

        &--wishlist {
            color: #000;
        }

        &.nuxt-link-exact-active {
            &:after {
                transform: scale(1, 1);
            }
        }
    }
    .col.tac {
        font-size: 0;
    }
    &__logo {
        display: grid;
        place-items: center;
        height: 36px;
        grid-template-areas: "logo";
        img {
            .trs(all);
            grid-area: logo;
            transform: scale(1);
            + img {
                opacity: 0;
                transform: scale(0.8);
            }
        }
        .scrolled & {
            img {
                opacity: 0;
                transform: scale(0.8);
                + img {
                    opacity: 1;
                    transform: scale(1);
                }
            }
        }
    }

    &__right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    &__wishlist a {
        transition: all 0s linear;
    }

    &__wishlist,
    &__wishlist a,
    &__cart {
        display: flex;
        align-items: center;
    }

    &__mid {
        text-align: center;
    }

    &__cart {
        cursor: pointer;
        margin-right: -19px;

        &--has-items {
            margin-right: -8px;
        }

        .fade-enter-active {
            position: relative;
            z-index: 6;
        }

        &-count {
            margin-left: 2px;

            .is_apple & {
                padding-top: 2px;
            }
        }

        &-toggle {
            position: relative;
            display: flex;
            align-items: center;

            &::before {
                content: "";
                display: block;
                position: absolute;
                top: -2px;
                bottom: -2px;
                left: -8px;
                right: -16px;
            }
        }
    }

    &__hover {
        cursor: pointer;
        height: 36px;
        .trs(background);
        min-width: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;

        &:hover,
        &.is_active {
            background: @border2;
        }

        &--user {
            position: relative;
        }

        svg {
            flex-shrink: 0;
        }
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

.fresh-item {
    border: 1px solid @border2;
    border-right: 0;
    position: fixed;
    top: 40px;
    right: 0;
    z-index: 6;
    overflow: hidden;

    .header__wishlist & {
        width: 360px;
    }

    .liveFreshItem-enter-active &,
    .liveFreshItem-leave-active & {
        animation: fade 0.6s ease forwards;
    }

    .liveFreshItem-leave-active & {
        animation: fadeOut 0.6s ease forwards;
    }

    &__content {
        display: flex;
        background: #fff;
    }

    &__img {
        width: 58px;
    }

    &__data {
        padding: 16px;
        width: 100%;

        .fresh-item__content + & {
            border-left: 1px solid @border2;
            padding-right: 100px;
        }

        .flex-c .flex-c {
            margin-left: auto;

            svg {
                position: relative;
                top: 1px;

                .is_apple & {
                    top: -1px;
                }
            }
        }
    }

    &__title {
        margin-bottom: 4px;
    }

    &__color {
        margin-bottom: 13px;
    }

    &__footer {
        display: flex;

        span {
            margin-right: 4px;
        }
    }

    &__count {
        margin-left: 16px;
    }

    &__links {
        margin-top: 24px;
        text-decoration: underline;

        a + a {
            margin-left: 16px;
        }
    }
}

.empty-cart {
    padding: 32px;
}

.cart {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    .container {
        position: static;
    }

    &__dimmer {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0.7;
        background: #f2f1e9;
        z-index: 0;
    }

    &__modal {
        width: 645px;
        position: absolute;
        z-index: 1;
        background: @bg;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
    }

    &__header {
        height: 35px;
        border-bottom: 1px solid @border2;

        .container {
            display: flex;
            height: 100%;
            align-items: center;
        }
    }

    &__count {
        color: @text_3;

        &:before {
            content: "/";
            display: inline-block;
            margin: 0 8px;
        }
    }

    &__close {
        margin-left: auto;
        color: @text_3;
        cursor: pointer;
        .trs(color);

        &:hover {
            color: #000;
        }
    }

    &__list {
        overflow: hidden;
        flex-grow: 1;

        .container {
            padding: 32px;
            height: 100%;
            overflow-y: auto;
        }
    }

    &__checkout {
        a {
            background: #000;
            color: #fff;
            display: flex;
            padding: 20px;
            justify-content: center;

            &:hover {
                background: @text_2;
            }
        }
    }
}

.summary {
    padding: 32px 0;
    border-bottom: 1px solid @border2;

    &__item {
        display: flex;
        justify-content: space-between;

        & + & {
            margin-top: 4px;
        }

        &:last-child {
            margin-top: 16px;
        }
    }
}

.cart-item {
    display: flex;

    & + & {
        margin-top: 32px;
    }

    &__header {
        margin-bottom: 12px;
    }

    &__footer {
        margin-top: auto;
    }

    &__img {
        width: 160px;
        margin-right: 16px;
    }

    &__data {
        padding-top: 10px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    &__row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & + & {
            margin-top: 4px;
        }
    }

    &__count {
        margin-left: 16px;
    }

    &__color {
        display: flex;
        align-items: center;
        color: @text_3;

        svg {
            margin-right: 6px;
            display: block;
        }
    }

    &__remove {
        opacity: 0.5;
        cursor: pointer;
        .trs(opacity);

        &:hover {
            opacity: 1;
        }
    }

    &__col {
        display: flex;
        align-items: center;
    }

    &__full-price {
        color: #cc7d6c;
        text-decoration: line-through;
    }
}

.flex {
    display: flex;
}

.flex-e {
    justify-content: flex-end;
}

.header-user {
    &:hover {
        color: @red2;
    }
}

.user-name {
    padding-right: 8px;
}
</style>
